export default __webpack_public_path__ + "static/media/photo_gallery_11.8551f0fc.png";